import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTools = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.4 16.145 5.899-5.898a2.94 2.94 0 0 0 0-4.157l-2.216-2.215a2.94 2.94 0 0 0-4.157 0L4.028 9.773a2.94 2.94 0 0 0 0 4.157l2.216 2.215a2.94 2.94 0 0 0 4.157 0M3 20.986h4.371M16.808 6.762h-9.77m9.255 3.5H3.637m9.146 3.5h-8.9M15.182 11.627l5.258 5.258a1.91 1.91 0 0 1 0 2.7l-.702.703a1.91 1.91 0 0 1-2.7 0l-5.259-5.259M16.14 19.158l3.17-3.17"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTools);
export default ForwardRef;
